import templateUrl from "emun.salesrep/top-selling-subcategories.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";

export class TopSellingSubCategoriesController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.vendors = [];
    $ctrl.vendorQuery = new AutoQuery({
      url: "QueryVendors.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (v) {
          $ctrl.vendors.push(v.label);
        });
      },
    });
    var url = "QueryTopSellingSubCategories.json?GroupBy=Description&Sum=YTD";
    if ($ctrl.customer) {
      url = url + "&CustomerId=" + $ctrl.customer.id;
    }
    if ($ctrl.rep) {
      url = url + "&RepId=" + $ctrl.rep.id;
    }
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== "ALL") {
        url = url + "&RepGroupName=" + $ctrl.repGroup;
      }
    }

    var records;
    this.topSubCategories = new AutoQuery({
      url: url,
      autoLoad: true,
      take: 1000,
      pageSize: 1000,
      onLoaded: function (args) {
        records = _.sortBy(args.results, "sumYTD").reverse();

        $ctrl.topSubSortedCount = args.results.length;
        $ctrl.currentPage = 1;
        $ctrl.itemsPerPage = 10;

        $ctrl.pageChanged();
      },
    });

    $ctrl.pageChanged = function () {
      //console.info('Page changed to: ' + $ctrl.currentPage);
      var pagedData = records.slice(
        ($ctrl.currentPage - 1) * 10,
        $ctrl.currentPage * 10
      );
      $ctrl.topSubSorted = pagedData;
    };
  }
  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      $ctrl.topSubCategories.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}

export default {
  bindings: {
    collapsed: "=?",
    rep: "<",
    repGroup: "@",
    customer: "<",
    context: "@",
    title: "@",
  },
  controller: TopSellingSubCategoriesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
